import React, { useContext } from 'react';
import { Modal } from 'antd';
import { AppStoreContext } from '../../context/appStoreContext';
import loginError from '../../images/loginError.png'


const AccessInterruptedModal = () => {

  const { sessionExpired, reAuthenticate } = useContext(AppStoreContext);

  return (
    <>
      {(sessionExpired || reAuthenticate) &&
        <Modal
          closable={false}
          footer={null}
          visible={(sessionExpired || reAuthenticate)}
          okButtonProps={{ style: { display: 'none' } }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', marginBottom: '14px', marginTop: '20px' }}>
            <img style={{ width: '50%', height: '50%', display: 'flex', justifyContent: 'space-between' }} src={loginError} alt="blank-canvas" />
            {reAuthenticate && <div style={{ fontSize: '18px', fontFamily: 'Lato' }}><p style={{ fontSize: '18px' }}>Authentication was unsuccessful.</p>
              <p style={{ fontSize: '18px' }}> Please re-authenticate to proceed</p></div>}
            {sessionExpired && <div style={{ fontSize: '18px', fontFamily: 'Lato' }}><p style={{ fontSize: '18px' }}>Session Expired. Please Login to proceed</p>
            </div>}
          </div>
        </Modal>
      }
    </>
  );
};

export default AccessInterruptedModal;